/** @format */

import {forwardRef} from 'react';

import classNames from 'classnames';

export const TextLink = forwardRef(({secondary, alt, children, ...props}, ref) => {
    const linkClass = classNames('text-link', {
        'text-link--secondary': !!secondary,
        'text-link--alt': !!alt
    });

    return (
        <a {...props} className={linkClass} ref={ref}>
            {children}
        </a>
    );
});

export default TextLink;

TextLink.displayName = 'TextLink';
